import { useEffect, useRef } from 'react';
import { Input } from '@/components/ui/FormControls';

export default function SaleSelectionCheckbox({
  label,
  checked,
  mixed = false,
  disabled = false,
  onChange,
}: {
  label: string;
  checked: boolean;
  mixed?: boolean;
  disabled?: boolean;
  onChange: () => void;
}) {
  const input = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (input.current) input.current.indeterminate = mixed;
  }, [mixed]);
  return (
    <label className="inline-flex min-h-11 min-w-11 shrink-0 cursor-pointer items-center justify-center">
      <Input
        ref={input}
        type="checkbox"
        aria-label={label}
        checked={checked}
        aria-checked={mixed ? 'mixed' : checked}
        disabled={disabled}
        onChange={onChange}
        className="h-4 w-4 accent-primary disabled:opacity-50"
      />
    </label>
  );
}
